import { useFilterFamilyOptions } from '../../../hooks/useFilterFamilyOptions';
import { useFilterFamilySelect } from '../../../hooks/useFilterFamilySelect';
import GroupOption from './general/GroupOption';
import DataExplorerEmptyState from './general/DataExplorerEmptyState';
import { isAnyEventTypeId } from '../../../filterQueryFormat/ObjectTypeId';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FilterFamilySubGroupSelectOptions = ({
  searchString
}) => {
  const {
    filterFamilyOptions
  } = useFilterFamilyOptions(searchString);
  const {
    disabledFilterFamilies,
    onFilterFamilySelect
  } = useFilterFamilySelect();
  if (filterFamilyOptions.length === 0 || filterFamilyOptions[0].options.length === 0) {
    return /*#__PURE__*/_jsx(DataExplorerEmptyState, {
      message: "customerDataFiltersUI.dataExplorer.emptyState.noOptions"
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: filterFamilyOptions[0].options.map((option, childIndex) => /*#__PURE__*/_jsx(GroupOption, {
      categoryLabel: option.text,
      dataSeleniumInfo: option.value,
      dataSeleniumTest: "fr-filter-family-option",
      disabled: disabledFilterFamilies[option.value],
      hideIcon: true,
      onClick: () => {
        void (async () => {
          try {
            await onFilterFamilySelect(option);
          } catch (e) {
            console.error('Error selecting filter family:', e);
          }
        })();
      },
      showInfoIcon: isAnyEventTypeId(option.value)
    }, `${childIndex}-${option.text}`))
  });
};
export default FilterFamilySubGroupSelectOptions;